// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const AdSenseForm = () => {
//   const [apiKey, setApiKey] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [response, setResponse] = useState(null);
//   const [error, setError] = useState("");
//   const [adsenseList, setAdsenseList] = useState([]);
//   const [isUpdate, setIsUpdate] = useState(false);
//   const [selectedId, setSelectedId] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   useEffect(() => {
//     fetchAdsenseData();
//   }, []);

//   const fetchAdsenseData = async () => {
//     try {
//       const result = await axios.get("api/admin/google-adsence-api/");
//       setAdsenseList(result.data);
//     } catch (err) {
//       setError("Failed to fetch AdSense data.");
//     }
//   };

//   const handleApiKeyChange = (e) => {
//     setApiKey(e.target.value);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");
//     setResponse(null);

//     try {
//       const apiUrl = isUpdate
//         ? `api/admin/google-adsence-api/${selectedId}/`
//         : "api/admin/google-adsence-api/";

//       const method = isUpdate ? "put" : "post";

//       const result = await axios[method](apiUrl, { apiKey });

//       setResponse(result.data);

//       setApiKey("");
//       setIsUpdate(false);
//       setSelectedId(null);
//       fetchAdsenseData();
//       setShowModal(false);
//     } catch (err) {
//       setError("An error occurred while submitting the AdSense data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (id, apiKey) => {
//     setSelectedId(id);
//     setApiKey(apiKey);
//     setIsUpdate(true);
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`api/admin/google-adsence-api/${id}/`);
//       fetchAdsenseData();
//     } catch (err) {
//       setError("Failed to delete the AdSense data.");
//     }
//   };

//   const Modal = ({ children, isVisible, onClose }) => {
//     if (!isVisible) return null;

//     return (
//       <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
//         <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
//           <button
//             onClick={onClose}
//             className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
//           >
//             <span className="font-semibold text-2xl">×</span>
//           </button>
//           {children}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-[90vh] w-full flex items-center justify-center">
//       <div className=" mx-auto p-6 bg-white rounded-lg shadow-lg w-full">
//         <h1 className="text-2xl font-bold text-center mb-6">
//           {isUpdate ? "Update" : "Add"} Your API Key to AdSense
//         </h1>

//         <button
//           onClick={() => setShowModal(true)}
//           className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 mb-4"
//         >
//           {isUpdate ? "Edit Existing" : "Add New API Key"}
//         </button>

//         <Modal isVisible={showModal} onClose={() => setShowModal(false)}>
//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div className="flex flex-col">
//               <label htmlFor="apiKey" className="text-lg font-medium mb-2">
//                 API Key
//               </label>
//               <input
//                 type="text"
//                 id="apiKey"
//                 name="apiKey"
//                 value={apiKey}
//                 onChange={handleApiKeyChange}
//                 placeholder="Enter your API Key"
//                 className="p-3 border border-gray-300 rounded-md text-lg"
//                 required
//               />
//             </div>

//             <button
//               type="submit"
//               className={`w-full py-3 text-white font-semibold rounded-md transition-all duration-300 ${
//                 loading
//                   ? "bg-gray-400 cursor-not-allowed"
//                   : "bg-orange-500 hover:bg-orange-600"
//               }`}
//               disabled={loading}
//             >
//               {loading ? "Loading..." : isUpdate ? "Update" : "Submit"}
//             </button>
//           </form>

//           {error && <p className="mt-6 text-red-500 text-lg">{error}</p>}
//         </Modal>

//         {/* Display the list of AdSense data in table format */}
//         <div className="mt-8">
//           <h2 className="text-xl font-semibold">AdSense Data</h2>
//           <div className="overflow-x-auto mt-4">
//             <table className="min-w-full table-auto">
//               <thead>
//                 <tr className="bg-gray-100">
//                   <th className="px-4 py-2 border-b">ID</th>
//                   <th className="px-4 py-2 border-b">API Key</th>
//                   <th className="px-4 py-2 border-b text-right">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {adsenseList.length > 0 ? (
//                   adsenseList.map((item) => (
//                     <tr key={item.id} className="border-b">
//                       <td className="px-4 py-2">{item.id}</td>
//                       <td className="px-4 py-2">{item.apiKey}</td>
//                       <td className="px-4 py-2 text-right space-x-2">
//                         <button
//                           onClick={() => handleEdit(item.id, item.apiKey)}
//                           className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//                         >
//                           Edit
//                         </button>
//                         <button
//                           onClick={() => handleDelete(item.id)}
//                           className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//                         >
//                           Delete
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="3" className="text-center py-4">
//                       No AdSense data available.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdSenseForm;

// import React, { useEffect, useState } from "react";
// import {
//   Pagination,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
// } from "@mui/material";
// import axios from "axios";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Modal from "@mui/material/Modal";
// import TextField from "@mui/material/TextField";
// import AddIcon from "@mui/icons-material/Add";
// import { toast } from "react-toastify";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 500,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
//   rounded: 2,
// };

// const AdSenseForm = () => {
//   const [page, setPage] = useState(1);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPage, setTotalPage] = useState(null);
//   const [productData, setProductData] = useState([]);
//   const [open1, setOpen1] = React.useState(false);
//   // const [page, setPage] = React.useState(1);
//   const [searchQuery, setSearchQuery] = useState("");
//   // Add category Name start
//   const [mainCategoryId, setMainCategoryId] = useState(null);
//   const [product_category_name, setProduct_category_name] = useState("");
//   const [image, setImage] = useState("");
//   // const [description, setDescription] = useState("");
//   const [meta_title, setMeta_title] = useState("");
//   const [meta_description, setMeta_description] = useState("");
//   const [meta_keyword, setMeta_keyword] = useState("");
//   const storeId = localStorage.getItem("store_id");
//   // const superuserId = localStorage.getItem("is_superuser");
//   const superuserId = "true";

//   const Page = (e) => {
//     console.log(e.target.files);
//     setImage(e.target.files[0]);
//   };

//   const submitCategory = () => {
//     const fd = new FormData();
//     fd.append("main_category_id", mainCategoryId);
//     fd.append("product_category_name", product_category_name);
//     // fd.append("description", description);
//     mainCategoryId === null
//       ? fd.append("image", image)
//       : image && fd.append("image", image);
//     fd.append("meta_title", meta_title);
//     fd.append("meta_description", meta_description);
//     fd.append("meta_keyword", meta_keyword);
//     mainCategoryId !== null && fd.append("store_id", storeId);
//     mainCategoryId === null
//       ? axios
//           .post(
//             `https://app1.crazzyhub.com/api/admin/google-adsense-api/`,
//             fd,
//             {
//               headers: {
//                 Token: localStorage.getItem("Token"),
//                 "Content-Type": "multipart/formdata",
//               },
//             }
//           )
//           .then((response) => {
//             toast.success(response.data.message);
//             console.log("business store ==>", response.data.data);
//             handleClose1();
//             ProductDataList();
//           })
//           .catch((error) => {
//             console.log("error page", error.response);
//             console.log(error);
//           })
//       : // Edit functionality to business category
//         axios
//           .post(
//             `https://app1.crazzyhub.com/api/admin/google-adsense-api/`,
//             fd,
//             {
//               headers: {
//                 Token: localStorage.getItem("Token"),
//                 "Content-Type": "multipart/formdata",
//               },
//             }
//           )
//           .then((response) => {
//             toast.success(response.data.message);
//             handleClose1();
//             ProductDataList();
//           })
//           .catch((error) => {
//             console.log("error page", error.response);
//             console.log(error);
//           });
//   };

//   const handleOpen1 = () => setOpen1(true);
//   const handleClose1 = () => setOpen1(false);

//   const ProductDataList = () => {
//     superuserId !== "true"
//       ? axios
//           .post(
//             `https://app1.crazzyhub.com/api/admin/google-adsense-api/?page=${page}`,
//             {},
//             {
//               headers: {
//                 Token: localStorage.getItem("Token"),
//               },
//             }
//           )
//           .then((response) => {
//             console.log(
//               "category list data===>",
//               response?.data?.main_category_data
//             );

//             setCurrentPage(response.data.current_page);
//             setTotalPage(response.data.total_pages);
//             setProductData(response?.data?.main_category_data);
//           })
//           .catch((error) => {
//             console.log("", error);
//           })
//       : axios
//           .post(
//             `https://app1.crazzyhub.com/api/admin/google-adsense-api/`,
//             {},
//             {
//               headers: {
//                 Token: localStorage.getItem("Token"),
//               },
//             }
//           )
//           .then((response) => {
//             setCurrentPage(response.data.current_page);
//             setTotalPage(response.data.total_pages);
//             setProductData(response?.data?.main_category_data);
//           })
//           .catch((error) => {
//             console.log("", error);
//           });
//   };
//   useEffect(() => {
//     ProductDataList();
//   }, [page]);

//   const EditFunction = (row) => {
//     setMainCategoryId(row?.id);
//     setProduct_category_name(row?.category);
//     setMeta_description(row?.Meta_Description);
//     setMeta_title(row?.Meta_Title);
//     setMeta_keyword(row?.Meta_Keyword);
//   };

//   const hangleCancel = () => {
//     setMainCategoryId("");
//     setProduct_category_name("");
//     setMeta_description("");
//     setMeta_title("");
//     setMeta_keyword("");
//     handleClose1();
//     ProductDataList();
//   };

//   const handleOpenModal = () => {
//     setProduct_category_name("");
//     setMeta_description("");
//     setMeta_title("");
//     setMeta_keyword("");
//     setMainCategoryId("");
//   };
//   const deleteCategory = (id) => {
//     axios
//       .delete(`https://app1.crazzyhub.com/api/admin/google-adsense-api/`, {
//         data: {
//           main_category_id: id,
//           // store_id: StoreID,
//         },

//         headers: {
//           Token: localStorage.getItem("Token"),
//         },
//       })
//       .then((response) => {
//         if (response.data.response_code == 200) {
//           toast.success(response.data.message);
//           ProductDataList();
//         } else {
//           toast.error(response.data.message);
//         }
//       })
//       .catch((error) => {
//         console.log("error page", error.response);
//         console.log(error);
//       });
//     // }
//   };
//   const handleChangePage = (event, value) => {
//     setPage(value);
//   };
//   return (
//     <div className=" !bg-slate-100">
//       <div className="flex justify-between">
//         <div className="p-2">
//           <p className="text-xl !text-black font font-bold">Manage AddSence</p>
//         </div>
//         <div className="p-2 pt-5"></div>
//       </div>
//       <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
//         <div className="flex items-center justify-between my-2">
//           <span className="flex  gap-3">
//             <input
//               type="text"
//               value={searchQuery}
//               className="!border-3 !border-black !w-72 mx-3 px-2 rounded-md py-1"
//               placeholder="search"
//               style={{ border: "1px solid black" }}
//               onChange={(event) => setSearchQuery(event.target.value)}
//             />
//           </span>
//           <span>
//             <div className="text-red-500 mx-3">
//               {superuserId === "true" ? (
//                 <Button
//                   variant="outlined"
//                   color="primary"
//                   onClick={handleOpen1}
//                 >
//                   <AddIcon />
//                   Add AddSence Key
//                 </Button>
//               ) : null}
//               <Modal
//                 open={open1}
//                 onClose={handleClose1}
//                 aria-labelledby="child-modal-title"
//                 aria-describedby="child-modal-description"
//               >
//                 <Box
//                   sx={{ ...style, width: 430 }}
//                   className="rounded-2xl !border-0"
//                 >
//                   <div
//                     id="child-modal-title "
//                     className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
//                     onClick={handleOpenModal}
//                   >
//                     {mainCategoryId === null
//                       ? "Add AddSence"
//                       : "Update AddSence"}
//                   </div>
//                   <TextField
//                     size="small"
//                     value={product_category_name}
//                     onChange={(event) =>
//                       setProduct_category_name(event.target.value)
//                     }
//                     id="outlined-basic"
//                     label="Category Name"
//                     variant="outlined"
//                     className="!w-[100%] !mt-2"
//                   />
//                   {/* <br />
//                   <TextField
//                     onChange={Page}
//                     id="outlined-basic"
//                     type="file"
//                     size="small"
//                     className="!w-[100%] !mt-3"
//                   />
//                   <br />
//                   <TextField
//                     value={meta_title}
//                     onChange={(event) => setMeta_title(event.target.value)}
//                     id="outlined-basic"
//                     label="Title"
//                     size="small"
//                     variant="outlined"
//                     className="!w-[100%] !mt-3"
//                   />
//                   <br />
//                   <TextField
//                     value={meta_description}
//                     onChange={(event) =>
//                       setMeta_description(event.target.value)
//                     }
//                     id="outlined-basic"
//                     // defaultValue="Small"
//                     size="small"
//                     label="Meta Description"
//                     variant="outlined"
//                     className="!w-[100%] !mt-3"
//                   />
//                   <br />
//                   <TextField
//                     value={meta_keyword}
//                     onChange={(event) => setMeta_keyword(event.target.value)}
//                     id="outlined-basic"
//                     label="Meta Keyword"
//                     // defaultValue="Small"
//                     size="small"
//                     variant="outlined"
//                     className="!w-[100%] !mt-2"
//                   /> */}
//                   <br />
//                   <Button
//                     onClick={hangleCancel}
//                     variant="contained"
//                     color="warning"
//                     className="!py-2 !mt-3"
//                   >
//                     CANCEL
//                   </Button>
//                   {mainCategoryId === null ? (
//                     <Button
//                       variant="contained"
//                       color="success"
//                       className="!py-2 !px-5 !font-bold !mt-3 !float-right"
//                       onClick={submitCategory}
//                     >
//                       ADD
//                     </Button>
//                   ) : (
//                     <Button
//                       variant="contained"
//                       color="success"
//                       className="!py-2 !px-5 !mt-3 !font-bold !float-right"
//                       onClick={submitCategory}
//                     >
//                       UPDATE
//                     </Button>
//                   )}
//                 </Box>
//               </Modal>
//             </div>
//           </span>
//         </div>
//         <TableContainer
//           component={Paper}
//           // sx={{  }}
//           sx={{ width: "100%", maxHeight: "71vh" }}
//           className="!text-black !mx-auto !bg-white overflow-auto px-2"
//         >
//           <Table stickyHeader aria-label="sticky table" size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   ID
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   BUSINESS TYPE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   BUSINESS SUB TYPE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   CATEGORY
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   IMAGE
//                 </TableCell>
//                 <TableCell
//                   style={{
//                     borderRight: "1px solid #D0D0D0",
//                     fontFamily: "'Poppins', sans-serif",
//                   }}
//                   className="!text-center !text-gray-800 !font-bold"
//                 >
//                   STATUS
//                 </TableCell>
//                 {superuserId === "true" ? (
//                   <TableCell
//                     style={{
//                       fontFamily: "'Poppins', sans-serif",
//                     }}
//                     className="!text-center !text-gray-800 !font-bold"
//                   >
//                     ACTION
//                   </TableCell>
//                 ) : null}
//               </TableRow>
//             </TableHead>
//             <TableBody className="!bg-red">
//               {productData &&
//                 productData?.map((row, index) => (
//                   <TableRow key={row.id} className="!text-slate-700">
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row.id}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.business_type?.business_type?.name
//                         ? row?.business_type?.business_type?.name
//                         : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {" "}
//                       {row?.business_type?.name
//                         ? row?.business_type?.name
//                         : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row.category ? row.category : "--"}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.image ? (
//                         <img
//                           src={row?.image}
//                           alt="No"
//                           className="h-8 mx-auto w-8"
//                         />
//                       ) : (
//                         "--"
//                       )}
//                     </TableCell>
//                     <TableCell
//                       className="!text-center !text-[12px]"
//                       style={{
//                         borderRight: "1px solid #D0D0D0",
//                         fontFamily: "'Poppins', sans-serif",
//                       }}
//                     >
//                       {row?.is_active_for_user ? (
//                         <CheckCircleIcon className="text-green-500" />
//                       ) : (
//                         "--"
//                       )}
//                     </TableCell>

//                     {superuserId === "true" ? (
//                       <TableCell
//                         className="!text-center !text-[12px]"
//                         style={{
//                           fontFamily: "'Poppins', sans-serif",
//                         }}
//                       >
//                         <DeleteIcon
//                           onClick={() => deleteCategory(row.id)}
//                           className="!text-xl !text-red-600 !cursor-pointer"
//                         />
//                         <button onClick={handleOpen1}>
//                           <EditIcon
//                             className="!text-xl !cursor-pointer !text-green-600"
//                             onClick={() => EditFunction(row)}
//                           />
//                         </button>
//                       </TableCell>
//                     ) : null}
//                   </TableRow>
//                 ))}
//             </TableBody>
//           </Table>
//           {/* {totalPage !== 1 && ( */}
//           <div className="flex justify-center p-2">
//             <Pagination
//               page={currentPage}
//               size="small"
//               count={totalPage}
//               variant="outlined"
//               color="primary"
//               onChange={handleChangePage}
//             />
//           </div>
//           {/* )} */}
//         </TableContainer>
//       </div>
//     </div>
//   );
// };

// export default AdSenseForm;

import React, { useState, useEffect } from "react";

import axiosInstance from "../../config/axios";
import { toast } from "react-toastify";

const AdSenseForm = () => {
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    fetchAdsenseData();
  }, []);

  const fetchAdsenseData = async () => {
    setLoading(true);
    try {
      const result = await axiosInstance.get("api/admin/google-adsense-api/");
      if (result?.data && result?.data?.data?.adsense_key) {
        setApiKey(result?.data?.data?.adsense_key);
        setIsUpdate(true);
      } else {
        setIsUpdate(false);
      }
    } catch (err) {
      setError("Failed to fetch AdSense data.");
    } finally {
      setLoading(false);
    }
  };

  const handleApiKeyChange = (e) => {
    setApiKey(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResponse(null);

    try {
      const apiUrl = isUpdate
        ? `api/admin/google-adsense-api/`
        : "api/admin/google-adsense-api/";

      const method = isUpdate ? "post" : "post";

      const result = await axiosInstance[method](apiUrl, {
        adsense_key: apiKey,
      });

      setResponse(result.data);
      toast.success(result?.data?.msg);

      fetchAdsenseData();
    } catch (err) {
      setError("An error occurred while submitting the AdSense data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[90vh] w-full flex items-center justify-center">
      <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-lg w-full">
        <h1 className="text-2xl font-bold text-center mb-6">
          {isUpdate ? "Update" : "Add"} Your API Key to AdSense
        </h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col">
            <label htmlFor="apiKey" className="text-lg font-medium mb-2">
              API Key
            </label>
            <input
              type="text"
              id="apiKey"
              name="apiKey"
              value={apiKey}
              onChange={handleApiKeyChange}
              placeholder="Enter your API Key"
              className="p-3 border border-gray-300 rounded-md text-lg"
              required
            />
          </div>

          <button
            type="submit"
            className={`w-full py-3 text-white font-semibold rounded-md transition-all duration-300 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-orange-500 hover:bg-orange-600"
            }`}
            disabled={loading}
          >
            {loading ? "Loading..." : isUpdate ? "Update" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdSenseForm;
